/* eslint-disable */
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import _ from "lodash/fp";
import ExamSubjectList from './ExamSubjectList';
import Devnagari from './devnagari';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import { getExamSubjectsListPagination, addExamSubjectData, getExamSubjectData, editExamSubjectData, resetExamSubject, resetExamSubjectsList, getAllExamSubjectsData } from '../actions/masterManagementAction';
import { SET_EXAMSUBJECT } from '../../../common/constants/ActionTypes';


const ExamSubjectForm = ({ addExamSubject, setAddExamSubject, setExamSubjectName, examSubjectCode, examSubjectName, examSubjectParentId, setExamSubjectParentId, setExamSubjectCode }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange"
  });

  const onSubmit = (data, addExamSubject, setAddExamSubject) => {
    let requestBody = {
      "examSubject": {
        "name": data.examSubjectName,
        "nameDvng": data.examSubjectNameDvng,
        "code": examSubjectCode,
        "isActive": data.isActive,
        "parentExamSubjectId": examSubjectParentId ? examSubjectParentId : null
      }
    };
    dispatch(resetExamSubjectsList());
    if (addExamSubject.Mode == 'Add') {
      dispatch(addExamSubjectData(requestBody, setAddExamSubject, setExamSubjectName, setExamSubjectCode));
    }
    else if (addExamSubject.Mode == 'Edit') {
      requestBody.examSubject.id = addExamSubject.id;
      requestBody.examSubject.code = examSubjectCode;
      requestBody.examSubject.parentExamSubjectId = addExamSubject.parentId ? addExamSubject.parentId : null;

      dispatch(editExamSubjectData(requestBody, setAddExamSubject, setExamSubjectName, setExamSubjectCode));
    }
  }

  useEffect(() => {
    if (addExamSubject && addExamSubject.Mode == 'Add') {
      dispatch(resetExamSubjectsList());
      setExamSubjectName('');
      // setExamSubjectNameDvng('');
      setExamSubjectCode('');
      setExamSubjectParentId('');
    }
    // dispatch(getAllExamSubjectsData());
    // addExamSubject.Mode == "Edit" && addExamSubject.id > 0 && dispatch(getExamSubjectData(addExamSubject.id));
    addExamSubject.Mode == "Edit" && addExamSubject.id > 0 && setExamSubjectName(addExamSubject.name);
    // addExamSubject.Mode == "Edit" && addExamSubject.id > 0 && setExamSubjectNameDvng(addExamSubject.name);
    addExamSubject.Mode == "Edit" && addExamSubject.id > 0 && setExamSubjectCode(addExamSubject.code);
    addExamSubject.Mode == "Edit" && addExamSubject.id > 0 && setExamSubjectParentId(addExamSubject.parentId);

    dispatch({
      type: SET_EXAMSUBJECT,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])

  const onChangeExamSubjactName = (e) => {
    setExamSubjectName(e.target.value)
    // setExamSubjectNameDvng(e.target.value)
  }

  const onChangeSubjectCode = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setExamSubjectCode(value);
  }
  const onChangeParentId = (e) => {
    setExamSubjectParentId(e.target.value)
  }
  const { examSubjectData, parentExamsubjectData } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setExamSubjectName('');
    dispatch(resetExamSubject());
    dispatch(resetExamSubjectsList());
    dispatch(getExamSubjectsListPagination(0, 10, ''));
    setAddExamSubject({ "Mode": false });
    setExamSubjectParentId('');


  }

  return addExamSubject.Mode == false ? (
    <div>
      <ExamSubjectList
        setAddExamSubject={setAddExamSubject}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addExamSubject.Mode == 'Add' ? masterLabels.examSubjectForm.Add_ExamSubject : masterLabels.examSubjectForm.Update_ExamSubject}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.examSubjectForm.Name}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="examSubjectName"
                  placeholder={masterLabels.examSubjectForm.Name}
                  ref={register({ required: true, maxLength: 200 })}
                  defaultValue={addExamSubject && addExamSubject.Mode == 'Edit' && addExamSubject.name ? addExamSubject.name : ''}
                  onChange={onChangeExamSubjactName}
                />
                {_.get("examSubjectName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("examSubjectName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_200}</p>
                )}
              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.examSubjectForm.Name_dvng}<span className="redColor">*</span></label>

                {examSubjectName ?
                  <Controller
                    name="examSubjectNameDvng"
                    control={control}
                    key="examSubjectNameDvng"
                    defaultValue={addExamSubject && addExamSubject.Mode == 'Edit' && addExamSubject.name_dvng ? addExamSubject.name_dvng : ''}
                    rules={{ required: true }}
                    render={({ onChange, value }) => (
                      <Devnagari placeholder={masterLabels.examSubjectForm.Name_dvng} onChange={onChange} value={value} />
                    )}
                  /> :
                  <Controller
                    name="examSubjectNameDvng"
                    control={control}
                    key="examSubjectNameDvng1"
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ onChange, value }) => (
                      <Devnagari placeholder={masterLabels.examSubjectForm.Name_dvng} onChange={onChange} value={value} />
                    )}
                  />
                }
                {_.get("examSubjectNameDvng.type", errors) === "required" && (
                  <p className="errorText float-left" >{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}

              </div>
              <div className='col-md-2' >
                <label className='font-weight-bold float-left' >{masterLabels.examSubjectForm.ExamCode}<span className="redColor">*</span></label>
                <input type="text"
                  className="form-control"
                  name="code"
                  value={examSubjectCode}
                  maxLength="20"
                  placeholder={masterLabels.examSubjectForm.ExamCode}
                  defaultValue={addExamSubject && addExamSubject.Mode == 'Edit' && examSubjectData && examSubjectData.examSubject && examSubjectData.examSubject.code}
                  ref={register({ required: true, maxLength: 20 })}
                  onChange={onChangeSubjectCode}
                />
                {_.get("code.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("code.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_20}</p>
                )}
              </div>

              <div className='col-md-2' >
                <label className='font-weight-bold float-left' >{masterLabels.examSubjectForm.ParentExamSubject}</label>
                <select
                  className="form-control"
                  name="parent_id"
                  value={examSubjectParentId}
                  onChange={onChangeParentId}
                  defaultValue={addExamSubject && addExamSubject.Mode == 'Edit' && examSubjectData && examSubjectData.examSubject && examSubjectData.examSubject.parentExamSubjectId}
                  disabled={(addExamSubject && addExamSubject.Mode == 'Edit') && true}
                >
                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {parentExamsubjectData && parentExamsubjectData.examSubjectList && parentExamsubjectData.examSubjectList.length > 0 && parentExamsubjectData.examSubjectList.map((element, index) =>
                    <option key={index} value={element.id}>{element.name}</option>
                  )}
                </select>
              </div>

              <div className='col-md-1'>
                <label className='font-weight-bold float-left  text-left w-100'>{masterLabels.examSubjectForm.Status}?&nbsp;&nbsp;</label>
                <input
                  className='float-left text-left'
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={examSubjectData && examSubjectData.examSubject && examSubjectData.examSubject.isActive}
                  ref={register({})}
                                         
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className='col-md-10'></div>
              <div className='col-md-2 text-right'>
                <button type="button" className="btn btn-secondary mr-2" onClick={() => onCancelButton()}>
                  {commonLabels.BUTTON_CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button   " onClick={handleSubmit((e) => { onSubmit(e, addExamSubject, setAddExamSubject); })}>
                  {commonLabels.BUTTON_SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ExamSubjectForm;